<template>
  <div class="flow-db-record-approval-diagram"
       v-loading="loading"
       element-loading-text="加载中...">
    <template v-if="diagramInfo">
      <el-main>
        <div class="scale">
          <el-button icon="el-icon-plus" size="small" @click="scale += 10" :disabled="scale >= 150" circle></el-button>
          <span>{{ scale }}%</span>
          <el-button icon="el-icon-minus" size="small" @click="scale -= 10" :disabled="scale <= 40" circle></el-button>
        </div>
        <div class="design" :style="'transform: scale('+ scale / 100 +');'">
          <process-tree-viewer @selectedNode="nodeSelected"/>
        </div>
      </el-main>
    </template>
    <template v-else-if="!loading">
      <Hint type="error">
        <div>流程图加载失败</div>
        <el-button size="mini" type="text" @click="loadDiagramInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import ProcessTreeViewer from '../../../../../../elements/flow/process/ProcessTreeViewer'
import Hint from '../../../../../../elements/Hint'
export default {
  name: 'FlowDbRecordApprovalDiagram',
  components: {
    ProcessTreeViewer,
    Hint
  },
  props: {
    id: {
      type: String,
      required: true
    },
    active: Boolean
  },
  provide () {
    return {
      $workflow: this.state
    }
  },
  data () {
    return {
      loading: false,
      diagramInfo: null,
      scale: 100,
      state: {
        nodeMap: new Map(),
        isEdit: null,
        selectedNode: {},
        selectFormItem: null,
        design: {
          process: null,
          formItems: []
        },
        runningList: [],
        noTakeList: [],
        endList: [],
        diagramMode: 'viewer',
        disableRoot: false
      }
    }
  },
  methods: {
    loadDiagramInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/flow/db/record/process/diagram',
        method: 'post',
        data: this.$qs.stringify({
          id: this.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.diagramInfo = response.data.diagramInfo || {}
              // 更新 state 数据
              if (this.diagramInfo.processJson) {
                this.state.design.process = JSON.parse(this.diagramInfo.processJson)
              }
              this.state.runningList = this.diagramInfo.runningList || []
              this.state.noTakeList = this.diagramInfo.noTakeList || []
              this.state.endList = this.diagramInfo.endList || []
              this.state.disableRoot = this.diagramInfo.disableRoot
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    nodeSelected (node) {
      this.state.selectedNode = node
    }
  },
  mounted () {
    this.loadDiagramInfo()
  },
  watch: {
    active (val) {
      if (val) {
        this.loadDiagramInfo()
      }
    }
  }
}
</script>

<style lang="scss">
.flow-db-record-approval-diagram {
  height: 100%;
  background-color: #f5f6f6;

  .el-main {
    height: 100%;
  }

  .design {
    margin-top: 100px;
    display: flex;
    transform-origin: 50% 0 0;
  }

  .scale {
    z-index: 999;
    position: absolute;
    top: 15px;
    right: 25px;

    span {
      margin: 0 10px;
      font-size: 15px;
      color: #7a7a7a;
      width: 50px;
    }
  }

  .node-config-content{
    padding: 0 20px 20px;
  }

  ::v-deep .el-drawer__body{
    overflow-y: auto;
  }
}
</style>
